import { useEffect } from "react";

export default function Meta({ title, description }) {
  useEffect(() => {
    // Set document language to Danish
    document.documentElement.lang = "da";

    // Set document title
    const fullTitle = title 
      ? `${title} | Nordsjællands Tømrer og Snedker`
      : "Nordsjællands Tømrer og Snedker";
    document.title = fullTitle;

    // Set meta description
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.setAttribute('name', 'description');
      document.head.appendChild(metaDesc);
    }
    metaDesc.setAttribute('content', description || "Nordsjællands Tømrer og Snedker udfører professionelt tømrerarbejde, terrasser og tagarbejde i Helsingør og Nordsjælland.");
  }, [title, description]);

  return null;
}
